<script>
  import LargeModal from "./../../shared/LargeModal.svelte";
  import JobCardForm from "./../Orders/JobCardForm.svelte";
  import Modal from "./../../shared/Modal.svelte";
  import EditStyleForm from "./EditStyleForm.svelte";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import RateModal from "./Utils/RateModal.svelte";
  import ProductPhoto from "./Utils/ProductPhoto.svelte";
  import loadData from "../../utils/loadData";

  let showJob = false;
  export let EDITABLE = false;
  export let photo;
  export let graphic;
  export let photo2;
  export let graphic2;
  export let _id;
  export let name;
  export let price;
  export let inventoryLevel;
  export let SKU;
  export let materialReq;
  export let class_;
  export let orderID;
  export let orderNumber;

  // JOB CARD STUFFS -----------------------------------------------
  export let type;

  // ALL DEPARTMENTS
  export let customerID;
  export let delDate;

  // CABINETRY DEPARTMENT + MACHINE DEPARTMENT ----------------------
  export let department;
  export let departmentTask;
  export let sprayPaint;

  // CABINETRY DEPARTMENT ONLY: NONE -------------------
  // MACHINE DEPARTMENT ----------------------
  export let foam;
  export let assembly;

  // MACHINIST --------------------------------
  export let machinist;
  export let description;
  export let framing;
  export let upholsterer;
  export let quality;
  export let fabricInfo;
  export let notes;
  export let repFoaming;
  export let meterage;
  export let cutter;
  export let cushions;

  // MACHINIST names...............
  export let framingFN;
  export let foamingFN;
  export let fabricInfoFN;
  export let cushionsFN;
  export let cutterFN;
  export let meterigeFN;
  export let qualityFN;

  // ---------------------------------------------------------------

  let showRateModal = false;
  let showEditStyleForm = false;

  let mult = (a, b) => {
    let result = Number.parseFloat(a) * Number.parseFloat(b);
    return result.toFixed(2);
  };

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/orders/with-style/${_id}`,
      { headers: { authorization: ls.get("jwt") } }
    );

    let usedIn = resItem?.data?.usedIn;

    if (usedIn) {
      alert(
        `${name} is being used in the Jobs database.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${name}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/fstyles/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleAdd = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    axios
      .put(
        `${$config.backendURL}/fstyles/increment/${_id}`,
        { qty },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        loadData();
        dispatch("delete");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div
  in:fade={{ duration: $config.f.time() }}
  class="tr border-b border-gray-100"
>
  <div style="min-width: 25rem; max-width: 25rem;" class="flex items-center">
    {#if EDITABLE}
      <button
        class="text-base btn btn-red-outline mr-2"
        on:click={handleDelete}
      >
        <i class="fas fa-trash" />
      </button>
      <button
        on:click={() => (showEditStyleForm = true)}
        class="text-base btn btn-green-outline mr-2"
      >
        <i class="fas fa-edit" />
      </button>
      <button
        class="text-base btn btn-primary-outline mr-2"
        on:click={handleAdd}
      >
        <i class="fas fa-plus" />
      </button>
    {/if}

    {#if materialReq?.length > 0}
      <button
        class="btn btn-secondary mr-2 uppercase"
        style="font-size: 0.75rem !important;"
        on:click={() => (showRateModal = true)}
      >
        <i class="fas fa-check-circle mr-2 text-brand text-base" />
        Bill of material {EDITABLE ? "" : "[Read-Only]"}
      </button>
    {:else}
      <button
        class="btn btn-secondary mr-2 uppercase"
        style="font-size: 0.75rem !important; border: 1px solid rgba(248, 113, 113, 0.5) !important;"
        on:click={() => (showRateModal = true)}
      >
        <i class="fas fa-exclamation-circle mr-2 text-red-400 text-base" />
        Bill of material
        {EDITABLE ? "" : "[Read-Only]"}
      </button>
    {/if}

    <div class="pr-2">
      <button
        on:click={() => (showJob = true)}
        class="btn btn-green uppercase whitespace-nowrap"
        style="width: 100% !important;"
      >
        Job Card
      </button>
    </div>
  </div>
  <div style="min-width: 20rem; max-width: 20rem;">
    <ProductPhoto
      {name}
      photo={photo?.replaceAll("cloudinary", "I-AM-GROOT-BRO")}
      graphic={graphic?.replaceAll("cloudinary", "I-AM-GROOT-BRO")}
      photo2={photo2?.replaceAll("cloudinary", "I-AM-GROOT-BRO")}
      graphic2={graphic2?.replaceAll("cloudinary", "I-AM-GROOT-BRO")}
    />
    {name}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {orderNumber}
  </div>
  <!-- <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{price}
  </div> -->
  <div style="min-width: 8.5rem; max-width: 8.5rem;">
    {class_}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;" class="mr-4">
    {#if materialReq?.length > 0}
      R{materialReq.reduce((sum, el) => sum + el.qtyReq * el.uPrice, 0)}
    {:else}
      <div class="flex items-center justify-start">
        <div class="text-xs px-2 py-1 flex items-center bg-red-100 rounded-md">
          <i class="fas fa-exclamation-triangle mr-1" />
          No bill of mat.
        </div>
      </div>
    {/if}
  </div>
  <div style="min-width: 5rem; max-width: 5rem;">
    {inventoryLevel}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">{SKU}</div>
  <!-- <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{mult(inventoryLevel, price)}
  </div> -->
</div>

<RateModal
  title={name}
  show={showRateModal}
  styleID={_id}
  {EDITABLE}
  on:modalClose={() => {
    showRateModal = false;
    setTimeout(() => {
      loadData();
      dispatch("reloadData");
    }, 1000);
  }}
/>

<Modal
  show={showEditStyleForm}
  on:modalClose={() => (showEditStyleForm = false)}
  xxl
>
  <EditStyleForm styleID={_id} />
</Modal>

<LargeModal on:modalClose={() => (showJob = false)} show={showJob}>
  <JobCardForm
    {_id}
    jobType={type}
    {customerID}
    {orderID}
    {delDate}
    {department}
    {departmentTask}
    {sprayPaint}
    {foam}
    {assembly}
    {machinist}
    {description}
    {framing}
    {upholsterer}
    {quality}
    {fabricInfo}
    {notes}
    {repFoaming}
    {meterage}
    {cutter}
    {cushions}
    {framingFN}
    {foamingFN}
    {fabricInfoFN}
    {cushionsFN}
    {cutterFN}
    {meterigeFN}
    {qualityFN}
    on:reloadData={() => dispatch("reloadData")}
  />
</LargeModal>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
